/*
 * @Author: your name
 * @Date: 2020-07-08 10:23:27
 * @LastEditTime: 2020-07-14 19:24:58
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /x-lib-ui/examples/demos/form-build-demo/form-schema-config/components/form-widget-calc.config.js
 */
const FormWidgetCalcConfig = {
  // 类型
  componentType: 'FORM_WIDGET_CALC',
  // 部件显示样式
  widgetConfig: {
    icon: 'x-lib-calc-icon',
    text: '公式',
    optionTitle: true,
    description: '用于对表单字段进行常规公式运算'
  },
  componentConfig: {
    uuid: `32bit uuid`,
    width: 6, // 3, 6, 9, 12
    height: 1,
    render: {
      ide: 'FormWidgetCalc',
      edit: 'FormWidgetCalc',
      read: 'FormWidgetCalc'
    },
    excludeComponentTypes: [
      'FORM_WIDGET_TABLE',
      'FORM_WIDGET_SPACE',
      'FORM_WIDGET_FILE',
      'FORM_STATIC_TEXT',
      'FORM_STATIC_IMG',
      'FORM_WIDGET_SPLIT'
    ],
    componentValueTypes: {
      TEXT_INPUT: [
        'FORM_TEXT_INPUT',
        'FORM_TEXTAREA_INPUT',
        'FORM_PHONE_INPUT',
        'FORM_EMAIL_INPUT',
        'FORM_IDCARD_INPUT',
        'FORM_DOCUMENT_NUMBER',
        'FORM_RICH_TEXT',
        'FORM_STATIC_TEXT',
        'FORM_WIDGET_CALC'
      ],
      SELECT_INPUT: ['FORM_SELECT_INPUT', 'FORM_RADIO_INPUT', 'FORM_CHECKBOX_INPUT'],
      PEOPLE_SELECT: ['FORM_PEOPLE_SELECT'],
      DEPARTMENT_SELECT: ['FORM_DEPARTMENT_SELECT'],
      NUMBER_INPUT: ['FORM_NUMBER_INPUT', 'FORM_MONEY_INPUT'],
      DATE_SELECT: ['FORM_DATEPICK_INPUT']
    },
    judgeTypes: {
      TEXT_INPUT: [
        { label: '是', value: 'eq' },
        { label: '不是', value: 'notEq' },
        { label: '包含', value: 'in' },
        { label: '不包含', value: 'notIn' },
        { label: '开头为', value: 'startWith' },
        { label: '结尾为', value: 'endWith' },
        { label: '为空', value: 'isNull' },
        { label: '不为空', value: 'isNotNull' }
      ],
      DATE_SELECT: [
        { label: '是', value: 'eq' },
        { label: '不是', value: 'notEq' },
        { label: '早于', value: 'before' },
        { label: '晚于', value: 'after' },
        { label: '在范围内', value: 'in' },
        { label: '不在范围内', value: 'notIn' },
        { label: '为空', value: 'isNull' },
        { label: '不为空', value: 'isNotNull' }
      ],
      SELECT_INPUT: [
        { label: '是', value: 'eq' },
        { label: '不是', value: 'notEq' },
        { label: '包含', value: 'in' },
        { label: '不包含', value: 'notIn' },
        { label: '为空', value: 'isNull' },
        { label: '不为空', value: 'isNotNull' }
      ],
      PEOPLE_SELECT: [
        { label: '是', value: 'eq' },
        { label: '不是', value: 'notEq' },
        { label: '包含', value: 'in' },
        { label: '不包含', value: 'notIn' },
        { label: '为空', value: 'isNull' },
        { label: '不为空', value: 'isNotNull' }
      ],
      DEPARTMENT_SELECT: [
        { label: '是', value: 'eq' },
        { label: '不是', value: 'notEq' },
        { label: '包含', value: 'in' },
        { label: '不包含', value: 'notIn' },
        { label: '为空', value: 'isNull' },
        { label: '不为空', value: 'isNotNull' }
      ],
      NUMBER_INPUT: [
        { label: '=', value: 'eq' },
        { label: '≠', value: 'notEq' },
        { label: '>', value: 'gt' },
        { label: '≥', value: 'ge' },
        { label: '<', value: 'lt' },
        { label: '≤', value: 'le' },
        { label: '在范围内', value: 'in' },
        { label: '不在范围内', value: 'notIn' },
        { label: '为空', value: 'isNull' },
        { label: '不为空', value: 'isNotNull' }
      ]
    },
    lengthLimit: 200,
    calcRuleConfig: {
      ruleType: null,
      simpleRuleId: null,
      advancedRuleId: null
    },
    label: '公式组件',
    placeholder: '自动计算',
    readOnly: true,
    inTable: true,
    methods: {
      lcInitData: {
        edit: (...args) => {
          console.log(args)
        }
      }
    }
  },
  methods: {},
  editorConfig: ['INFO', 'LABEL', 'FORM_WIDGET_CALC_RULE', 'WIDTH', 'HIDDEN'],
  excludeEditorConfigInTable: ['WIDTH']
}

export default FormWidgetCalcConfig
